import classNames from 'classnames';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {getHeaders, getMPPEndpoint} from '../../../../helpers/endpoint';

const CURRENT_INTERNATIONAL_CHAMPIONSHIP_ID = 8; // 8 = CDM

export const getMPPScorers = (championshipId, onSuccess, onError) => {
  return (_dispatch, getState) => {
    fetch(getMPPEndpoint('getMPPScorers', championshipId), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          onError(data.error);
        } else {
          onSuccess(data);
        }
      })
      .catch(error => {
        onError && onError(error);
      });
  };
};

export const patchMPPScorer = (payload, onSuccess, onError) => {
  return (_dispatch, getState) => {
    fetch(
      getMPPEndpoint('patchMPPScorer', {
        championshipId: payload.championshipId,
        playerId: payload.playerId,
        cantWinAnymore: payload.cantWinAnymore,
      }),
      {
        method: 'PATCH',
        headers: getHeaders(getState().authentication),
      },
    )
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          onError(data.error);
        } else {
          onSuccess(data);
        }
      })
      .catch(error => {
        onError && onError(error);
      });
  };
};

class MPPScorers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      players: null,
    };
  }

  componentDidMount() {
    this.props.dispatch(
      getMPPScorers(CURRENT_INTERNATIONAL_CHAMPIONSHIP_ID, ({players}) => {
        this.setState({players});
      }),
    );
  }

  render() {
    const {players} = this.state;
    return (
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title pull-left">
            <i className="fa fa-user-circle-o" /> Scorers Live
          </h3>
        </div>
        <div className="box-body">
          <table className="table text-center table-striped">
            <thead>
              <tr>
                <th>Player</th>
                <th>Active</th>
                <th>Goals</th>
              </tr>
            </thead>
            <tbody>
              {players &&
                players.map(
                  player =>
                    Boolean(player.quotation) && (
                      <tr>
                        <td>
                          <b>{`${player.firstName} ${player.lastName}`}</b>
                          {` - ${player.quotation} pts`}
                        </td>
                        <td>
                          <i
                            onClick={() => {
                              swal({
                                title: 'Are you sure ?',
                                type: 'info',
                                showCloseButton: true,
                                showCancelButton: true,
                                focusConfirm: false,
                                confirmButtonText: 'Yes',
                                cancelButtonText: 'No',
                              })
                                .then(() => {
                                  this.props.dispatch(
                                    patchMPPScorer(
                                      {
                                        championshipId:
                                          CURRENT_INTERNATIONAL_CHAMPIONSHIP_ID,
                                        playerId: player.id,
                                        cantWinAnymore: !player.cantWinAnymore,
                                      },
                                      () => {
                                        this.props.dispatch(
                                          getMPPScorers(
                                            CURRENT_INTERNATIONAL_CHAMPIONSHIP_ID,
                                            ({players}) => {
                                              this.setState({players});
                                            },
                                          ),
                                        );
                                      },
                                    ),
                                  );
                                })
                                .catch(error => {
                                  console.log(error);
                                });
                            }}
                            className={classNames('fa fa-2x', {
                              'fa-toggle-on': !player.cantWinAnymore,
                              'fa-toggle-off': player.cantWinAnymore,
                            })}
                          />
                        </td>
                        <td>{player.goals || 0}</td>
                      </tr>
                    ),
                )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default connect()(MPPScorers);



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/MPPScorers/index.js